export default __webpack_public_path__ + "static/media/info.4fe7a5f7.svg";